import { GearInstance, StepperStep } from 'types';
import {getCommonFormProps} from "./commonData";

export const getUploadPhotoStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
): StepperStep => ({
  stepName: 'Upload Media',
  onPass: async (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Next',
    ...getCommonFormProps(onPass),
    fields: [
      {
        type: 'secondTitle',
        fieldName: 'step_title',
        value: 'Upload Media',
      },
      {
        type: 'description',
        fieldName: 'step_description',
        value: 'Clean backgrounds and attention to detail work best. Fell free to use stock photos, but photos of the actual item is a must. You can drag-n-drop images to change order.'
      },
      {
        type: 'videoPhotoBlock',
        fieldName: 'uploader',
        id: instance.id,
        value: {
          video: instance.video,
          images: instance.images || [],
        },
        draggable: true,
      },
    ],
  },
});
